module.exports = __webpack_public_path__ + "static/media/img22.20170cf6.png";